<div class="principal-container poppins-font">
  <div class="container_left_right">
    <div class="left_container" [class.hidden]="mostrarRightContainer">
      <div class="content_title">
        <h2>RASTREO DE ENVÍOS</h2>
        <h5>Dale seguimiento a tus envíos</h5>
      </div>

      <div class="content_rastreos">
        <div class="search_code">
          <input class="searchBar" [(ngModel)]="codigoBusqueda" type="text"
            placeholder="Ingresa o filtra código de rastreo">
          <button class="button_search" (click)="filtrarPorCodigo()">
            <img class="lupa" src="assets/iconos/busqueda.png"> Rastrear
          </button>
        </div>

        <div class="container_envios">
          <div class="total">
            Total de envíos: <span class="conteo">{{ rastreosFiltradosPorTexto().length }}</span>
          </div>

          <div class="tarjetas-rastreo">
            <div *ngFor="let rastreo of rastreosFiltradosPorTexto(); let i = index" class="tarjeta"
              [class.collapsed]="collapsedStates[i]">
              <div (click)="toggleCollapse(i)">
                <div class="img_box">
                  <img src="assets/iconos/package-box_black.png" />
                </div>

                <div class="rastreo_code">
                  <p>Rastreo</p>
                  <p>{{ rastreo.numrastreo }}</p>
                </div>

                <div class="statuscontent">
                  <p>Estatus</p>
                  <p>
                    {{
                    rastreo.timeline && rastreo.timeline.length > 0
                    ? rastreo.timeline[rastreo.timeline.length - 1].titulo
                    : 'Sin información'
                    }}
                  </p>
                </div>
              </div>

              <div class="arrowcontent" (click)="toggleCollapse(i)">
                <i class="fas fa-chevron-down"></i>
              </div>

              <div class="verDetalles" (click)="verDetalles(i)">
                <i class="fas fa-eye"></i>
              </div>

              <div class="division"></div>

              <div class="container_info">
                <div class="info_delete">
                  <span>Información de envío</span>
                  <div class="btn_delete" title="Eliminar rastreo" (click)="eliminarRastreo(rastreo.numrastreo)">
                    <img src="assets/iconos/borrar.png" />
                  </div>
                </div>

                <div class="origen_destino">
                  <div class="linetitle">
                    <div>Origen</div>
                    <div class="arrow"></div>
                    <div>Destino</div>
                  </div>

                  <div class="linecitys">
                    <div>{{ rastreo.origen }}</div>
                    <div>{{ rastreo.destino }}</div>
                  </div>
                </div>

                <br />

                <div class="timeline">
                  <ng-container *ngFor="let paso of rastreo?.timeline; let j = index">

                    <!-- Paso completado que NO es el último -->
                    <div *ngIf="paso.completado && !esUltimoCompletado(rastreo.timeline, j)" class="step completed">
                      <div class="circle"></div>
                      <div class="content">
                        <strong>{{ paso.titulo }}</strong>
                        <span class="ubicacionactual">- {{ paso.ubicacion }}</span><br />
                        <small *ngIf="paso.fechaHora">{{ paso.fechaHora }}</small>
                      </div>
                    </div>

                    <!-- Paso completado que SÍ es el último -->
                    <div *ngIf="paso.completado && esUltimoCompletado(rastreo.timeline, j)" class="step current">
                      <div class="circle"></div>
                      <div class="content">
                        <strong>{{ paso.titulo }}</strong>
                        <span class="ubicacionactual">- {{ paso.ubicacion }}</span><br />
                        <small *ngIf="paso.fechaHora">{{ paso.fechaHora }}</small>
                      </div>
                    </div>

                  </ng-container>
                </div>

              </div>

              <div class="selectedBar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div appVisibility class="right_container slideInRight" [class.visible]="mostrarRightContainer"
      *ngIf="isRastreoExpandidoVisible(); else noInfo">

      <h6 (click)="ocultarDetalles()">
        < Volver</h6>


          <!-- Contenedor fijo que muestra detalles del rastreo seleccionado -->
          <div class="header_info" *ngIf="rastreoExpandido">
            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/package-box_black.png" />
                </div>
                <div class="info_forhd">
                  <p>Rastreo</p>
                  <p>{{ rastreoExpandido.numrastreo }}</p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/mapa_dir.png" />
                </div>
                <div class="info_forhd">
                  <p>Origen</p>
                  <p>{{ rastreoExpandido.origen }}</p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/mapa_dir.png" />
                </div>
                <div class="info_forhd">
                  <p>Destino</p>
                  <p>{{ rastreoExpandido.destino }}</p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/statusenvio.png" />
                </div>
                <div class="info_forhd">
                  <p>Estatus</p>
                  <p>{{ obtenerUltimoTituloCompletado(rastreoExpandido.timeline) }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- <ng-template #placeholderHeader>
            <div class="header_info defaultcontent">
             <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/package-box_black.png" />
                </div>
                <div class="info_forhd">
                  <p>Rastreo</p>
                  <p></p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/mapa_dir.png" />
                </div>
                <div class="info_forhd">
                  <p>Origen</p>
                  <p></p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/mapa_dir.png" />
                </div>
                <div class="info_forhd">
                  <p>Destino</p>
                  <p></p>
                </div>
              </div>
            </div>

            <div class="item_header">
              <div class="content-txt">
                <div class="img_box_hd">
                  <img src="assets/iconos/statusenvio.png" />
                </div>
                <div class="info_forhd">
                  <p>Estatus</p>
                  <p></p>
                </div>
              </div>
            </div>
            </div>
          </ng-template> -->


          <div class="content_map" *ngIf="debeMostrarMapa">
            <ng-container *ngIf="rastreoExpandido && mapaUrl">
              <iframe width="100%" height="100%" [src]="mapaUrl" style="border:0;" allowfullscreen loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </ng-container>
          </div>

          <div class="content_info_rastreo" *ngIf="rastreoExpandido"
            [ngClass]="{ 'modo-incidencia': registrarIncidenciaActivo && validaEsIncidencia() }">
            <!-- <div class="menu">
                    <div *ngFor="let opcion of opciones" class="menu-item" [ngClass]="{'active': opcion.nombre === opcionSeleccionada}" (click)="seleccionarOpcion(opcion.nombre)">
                      <i [class]="opcion.icono" style="margin-right: 2px;"></i>
                      <span class="name_opcion">{{ opcion.nombre }}</span>
                    </div>
                  </div> -->
            <div class="menu">
              <div *ngFor="let opcion of opcionesVisibles" class="menu-item"
                [ngClass]="{ 'active': opcion.nombre === opcionSeleccionada }"
                (click)="seleccionarOpcion(opcion.nombre)">
                <i [class]="opcion.icono" style="margin-right: 2px;"></i>
                <span class="name_opcion">{{ opcion.nombre }}</span>
              </div>
            </div>
            <div class="container_form">
              <div class="cont-seguimiento"
                [ngClass]="{ 'visible': opcionSeleccionada === 'Seguimiento' && pantallaTablet, 'oculto': !(opcionSeleccionada === 'Seguimiento' && pantallaTablet) }">
                <h4>Seguimiento del envío</h4>

                <div class="content_map2 seguimiento" *ngIf="mapaUrl">
                  <iframe width="100%" height="100%" [src]="mapaUrl" style="border:0;" allowfullscreen loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                  </iframe>
                </div>
              </div>
              <div *ngIf="opcionSeleccionada === 'Información'" class="infoenvio">
                <div class="content_infoEnvio" *ngIf="rastreoExpandido">
                  <h4 class="titleDestino">Información del envío</h4>

                  <div class="detalle-envio-container">
                    <div class="grid-informacion">
                      <div class="info-pareja">
                        <p class="label">Tipo de Entrega</p>
                        <p>{{rastreoExpandido?.tipoServicio}}</p>
                        <p *ngIf="rastreoExpandido?.direccionActual"
                          style="font-size: 13px; color: #666; margin-top: -2px;"><b>Sucursal:</b>
                          {{rastreoExpandido?.direccionActual}}
                        </p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Remitente</p>
                        <p>{{ rastreoExpandido?.remitente }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Destinatario</p>
                        <p>{{ rastreoExpandido?.destinatario }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Cantidad</p>
                        <p>{{ rastreoExpandido?.cantidad }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Tipo de Paquete</p>
                        <p>{{ rastreoExpandido?.tipoPaquete }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Tipo de Envío</p>
                        <p>{{ rastreoExpandido?.tipoEnvio }}</p>
                      </div>
                      <!-- <div class="info-pareja">
                          <p class="label">Seguro de Paquete</p>
                          <p>{{ rastreoExpandido?.seguro ? 'Sí' : 'No' }}</p>
                        </div> -->
                      <div class="info-pareja">
                        <p class="label">Rastreo Externo</p>
                        <p>{{ rastreoExpandido?.rastreoExt || 'No disponible' }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Código de Canje</p>
                        <p>{{ permisosEnvio?.codigoCanje || 'Sin codigo' }}</p>
                      </div>
                      <div class="info-pareja">
                        <p class="label">Factura</p>

                        <!-- Si está facturado, muestra descarga -->
                        <ng-container *ngIf="permisosEnvio?.Facturado === 1; else solicitarFactura">
                          <p>
                            <button type="button" class="btn_downloadFactura" (click)="descargarAmbos()">
                              Descargar
                            </button>
                          </p>
                        </ng-container>

                        <ng-template #solicitarFactura>
                          <p>
                            <a [routerLink]="['/facturacion']" target="_blank" (click)="onSolicitarFacturaClick()">
                              Solicitar Factura
                            </a>
                          </p>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <!-- <table class="responsive-table">
                      <thead>
                        <tr>
                          <th>Entrega estimada</th>
                          <th>Remitente</th>
                          <th>Destinatario</th>
                          <th>Cantidad</th>
                          <th>Tipo Paquete</th>
                          <th>Tipo de envío</th>
                          <th>Seguro de paquete</th>
                          <th>Rastreo Ext.</th>
                          <th>Código canje</th>
                          <th>Facturación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Entrega estimada">{{ rastreoExpandido.entregaEstimada }}</td>
                          <td data-label="Remitente">{{ rastreoExpandido.remitente }}</td>
                          <td data-label="Destinatario">{{ rastreoExpandido.destinatario }}</td>
                          <td data-label="Cantidad">{{ rastreoExpandido.cantidad }}</td>
                          <td data-label="Tipo Paquete">{{ rastreoExpandido.tipoPaquete }}</td>
                          <td data-label="Tipo de envío">{{ rastreoExpandido.tipoEnvio }}</td>
                          <td data-label="Seguro de paquete">Seguro por extravío</td>
                          <td data-label="Rastreo Ext.">{{ rastreoExpandido.rastreoExt }}</td>
                          <td data-label="Código canje">Pendiente</td>
                          <td data-label="Facturación"><a href="#">Descargar factura</a></td>
                        </tr>
                      </tbody>
                    </table> -->
                </div>
              </div>

              <!-- <div *ngIf="opcionSeleccionada === 'Cambiar domicilio' && isLoguedin && rastreoExpandido.direccionActual?.trim()" class="actualizardestino"> -->
              <div *ngIf="opcionSeleccionada === 'Cambiar domicilio' && isLoguedin" class="actualizardestino">
                <div class="destinosguardados">
                  <h4>Asignar domicilio de destino</h4>

                  <div *ngIf="cargandoDestinos" class="loading">Cargando...</div>

                  <div *ngIf="!cargandoDestinos && !destinos?.length" class="empty">
                    <div class="centerEmpty">
                      <img src="assets/iconos/sin-dom.png" alt="Sin destinos">
                      <p>Tu lista está vacía. ¿Quieres añadir un destino?</p>
                      <p><b>Captura uno en el formulario</b></p>
                    </div>
                  </div>

                  <div class="list_destinos" *ngIf="!cargandoDestinos && destinos?.length">
                    <div class="destino-tarjeta" *ngFor="let destino of destinos; trackBy: trackById"
                      [ngClass]="{ 'activo': destino.esDestinoActual }">
                      <p class="destino-txt"><b>Recibe:</b> {{ destino.nombre }}</p>
                      <p class="destino-txt" style="padding: 0 25px 0px 5px;">{{ destino.direccion }}</p>
                      <p class="destino-txt" style="padding:0;">
                        <span *ngIf="destino.cp" class="cp">C.P.: {{ destino.cp }},</span>
                        <span class="citydestino">{{ destino.ciudad }}</span>
                      </p>

                      <div class="select-destino" [class.activo]="destino.esDestinoActual"
                        [class.inactivo]="!destino.esDestinoActual"
                        (click)="!guardandoPredeterminado && !destino.esDestinoActual && seleccionarDestino(destino)">
                        <i class="fa-solid fa-location-crosshairs"></i>
                        {{ destino.esDestinoActual ? 'Destino Predeterminado'
                        : (guardandoPredeterminado ? 'Guardando...' : 'Seleccionar como predeterminado') }}
                      </div>

                      <div class="btn_deleteDest" (click)="!eliminandoId && eliminarDestino(destino)"
                        [class.loading]="eliminandoId === destino.id" title="Eliminar domicilio">
                        <i class="far fa-trash"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-frmdestino">
                  <h4 class="titleDestino">Domicilio de entrega actual</h4>

                  <div class="selectedDestino" *ngIf="destinoSeleccionado; else sinSeleccion">
                    <p class="destino-txt">
                      {{ destinoSeleccionado.direccion }}
                    </p>
                    <p class="destino-txt" style="padding: 0;">
                      <span class="cp">C.P.:{{ destinoSeleccionado.cp }}</span>
                      <span class="citydestino">, {{ destinoSeleccionado.ciudad }}</span>
                    </p>
                  </div>

                  <!-- Si no hay actualmente un domicilio de entrega -->
                  <ng-template #sinSeleccion>
                    <div class="cont-destino">
                      <p class="destino-txt">{{rastreoExpandido?.direccionActual}}</p>
                    </div>
                  </ng-template>
                  <form [formGroup]="formDestino" (ngSubmit)="addnewdestino()" class="frm-newDestino" id="formDestino">
                    <h4 class="titleDestino">Nuevo domicilio de entrega</h4>

                    <!-- Estado y Ciudad -->
                    <div class="input-row" style="margin-bottom: 10px;">
                      <!-- <select formControlName="estado" class="selectTema">
                    <option value="" disabled selected>Estado</option>
                    <option *ngFor="let e of estados" [value]="e">{{ e.estado }}</option>
                  </select> -->

                      <select formControlName="estado" class="selectTema no-arrow" style="background: #f8f8f8;">
                        <option [ngValue]="rastreoExpandido?.idedo">
                          {{ rastreoExpandido?.estado }}
                        </option>
                      </select>

                      <select formControlName="ciudad" class="selectTema no-arrow" style="background: #f8f8f8;">
                        <option [ngValue]="rastreoExpandido?.idcd">
                          {{ rastreoExpandido?.ciudad }}
                        </option>
                      </select>
                    </div>

                    <!-- Colonia y Nombre -->
                    <div class="input-row">
                      <!-- <select formControlName="colonia" class="selectTema" [disabled]="!formDestino.get('ciudad')?.value">
                    <option value="" disabled selected>Colonia</option>
                    <option *ngFor="let col of colonias" [value]="col">{{ col.asenta }}</option>
                  </select> -->

                      <!-- Colonia -->
                      <select formControlName="colonia" class="selectTema"
                        [disabled]="!formDestino.get('estado')?.value || !formDestino.get('ciudad')?.value || colonias.length === 0">

                        <option [ngValue]="null" disabled>Colonia</option>
                        <option *ngFor="let col of colonias" [ngValue]="col.idcol">
                          {{ col.asenta }}
                        </option>
                      </select>
                      <input class="addnombre" type="text" placeholder="Nombre" formControlName="nombre">
                    </div>
                    <div class="input-row">
                      <div *ngIf="formDestino.get('colonia')?.invalid && formDestino.get('colonia')?.touched"
                        class="error">
                        Selecciona una colonia.
                      </div>
                      <div *ngIf="formDestino.get('nombre')?.invalid && formDestino.get('nombre')?.touched"
                        class="error">
                        El nombre es obligatorio.
                      </div>
                    </div>

                    <!-- Correo y Teléfono -->
                    <div class="input-row">
                      <input class="addcorreo" type="email" placeholder="Correo" formControlName="correo">
                      <input class="addtelefono" type="tel" placeholder="Teléfono" formControlName="telefono"
                        maxlength="10">
                    </div>
                    <div class="input-row">
                      <div *ngIf="formDestino.get('correo')?.invalid && formDestino.get('correo')?.touched"
                        class="error">
                        Ingresa un correo válido.
                      </div>
                      <div *ngIf="formDestino.get('telefono')?.invalid && formDestino.get('telefono')?.touched"
                        class="error">
                        El teléfono es obligatorio.
                      </div>
                    </div>

                    <!-- Dirección y Referencia -->
                    <div class="input-row">
                      <input class="adddireccion" type="text" placeholder="Dirección" formControlName="direccion">
                      <input class="addreferencia" type="text" placeholder="Referencia" formControlName="referencia">
                    </div>
                    <div class="input-row">
                      <div *ngIf="formDestino.get('direccion')?.invalid && formDestino.get('direccion')?.touched"
                        class="error">
                        La dirección es obligatoria.
                      </div>
                      <div *ngIf="formDestino.get('referencia')?.invalid && formDestino.get('referencia')?.touched"
                        class="error">
                        La referencia es obligatoria.
                      </div>
                    </div>

                    <!-- Botón -->
                    <div class="cont_btnUpdate">
                      <button class="btn_actualizardom" type="submit"
                        [disabled]="formDestino.invalid">Actualizar</button>
                    </div>
                  </form>
                </div>
              </div>

              <div *ngIf="opcionSeleccionada === 'Asistencia' && isLoguedin" class="solicitarasistencia">
                <div class="container_form">
                  <div class="info_contacto">
                    <h4 class="titleDestino">Contactanos vía</h4>
                    <div class="fila_contacto">
                      <i class="fa-solid fa-phone"></i> <span>(644) 410 2444</span>
                    </div>

                    <div class="fila_contacto">
                      <i class="fa-brands fa-whatsapp" style="font-size: 22px;"></i> <span>(644) 416 2668</span>
                    </div>
                    <div class="fila_contacto">
                      <i class="fa-solid fa-envelope"></i> <span>contacto&#64;tufesapack.com</span>
                    </div>
                  </div>
                  <div class="capturar_solicitud">
                    <h4 class="titleDestino">Captura tu solicitud</h4>
                    <form [formGroup]="formAsistencia" (ngSubmit)="onSubmitAsistencia()" class="frm-newAsistencia">
                      <input type="text" placeholder="Nombre completo" formControlName="nombre" class="inpt-asis">
                      <div *ngIf="formAsistencia.get('nombre')?.invalid && formAsistencia.get('nombre')?.touched"
                        class="error">
                        El nombre es obligatorio.
                      </div>
                      <input type="email" placeholder="Correo" formControlName="correo" class="inpt-asis">
                      <div *ngIf="formAsistencia.get('correo')?.invalid && formAsistencia.get('correo')?.touched"
                        class="error">
                        Ingresa un correo válido.
                      </div>
                      <input type="tel" placeholder="Teléfono o Celular" formControlName="telefono" class="inpt-asis"
                        maxlength="10">
                      <div *ngIf="formAsistencia.get('telefono')?.invalid && formAsistencia.get('telefono')?.touched"
                        class="error">
                        El teléfono es obligatorio y debe contener exactamente 10 dígitos.
                      </div>
                      <select formControlName="tema" class="selectTema forslct">
                        <option [ngValue]="null" disabled>Seleccione tema relacionado</option>
                        <option *ngFor="let t of temas; trackBy: trackTema" [ngValue]="t.idtema">
                          {{ t.tema }}
                        </option>
                      </select>
                      <div *ngIf="formAsistencia.get('tema')?.invalid && formAsistencia.get('tema')?.touched"
                        class="error">
                        Selecciona un tema.
                      </div>
                      <textarea formControlName="mensaje" class="txt_mensaje forasis" placeholder="Mensaje"></textarea>
                      <div *ngIf="formAsistencia.get('mensaje')?.invalid && formAsistencia.get('mensaje')?.touched"
                        class="error">
                        El mensaje es obligatorio.
                      </div>
                      <div class="cont_btnUpdate">
                        <button type="submit" class="btn_actualizardom" [disabled]="formAsistencia.invalid">
                          Enviar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div *ngIf="opcionSeleccionada === 'Evidencia de entrega' && isLoguedin" class="evidenciaEntrega">
                <div class="left_content_evidencia">
                  <h2 class="title-evi">Evidencia de entrega</h2>
                  <p class="txt-sub">Firma y datos de recepcion de tu envío</p>
                </div>

                <div class="right_content_evidencia">
                  <!-- Si NO hay datos de entrega aún -->
                  <ng-container *ngIf="!(entregaActual && (entregaActual.msgnum == 1)); else evidenciaOK">
                    <div class="content-firma defaultcontent">
                      <div class="content-w">
                        <img src="assets/iconos/sin-firma.png">
                      </div>
                    </div>

                    <div class="info_recepcion">
                      <div class="line_recepcion">
                        No se cuenta con información de entrega disponible aún. Se mostrará cuando el paquete esté
                        entregado.
                      </div>
                    </div>
                  </ng-container>

                  <!-- Si SÍ hay datos de entrega -->
                  <ng-template #evidenciaOK>
                    <div class="content-firma">
                      <div class="content-w">
                        <img [src]="firmaUrl">
                      </div>
                    </div>

                    <div class="info_recepcion">
                      <div class="line_recepcion">
                        Recibido por: <span>{{ entregaActual?.recibe || '—' }}</span>
                      </div>
                      <div class="line_recepcion">
                        Fecha: <span>{{ fechaEntregaLegible || (entregaActual?.fechamov + ' ' + entregaActual?.horamov)
                          }} hrs.</span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div *ngIf="opcionSeleccionada === 'Notificaciones' && isLoguedin" class="notificacionesstatus">

                <!-- Lista configurada -->
                <div class="cont_info_notificaciones" *ngIf="notifs?.length; else sinNotifs">
                  <h4 class="titleDestino">Medios de notificacion registrados</h4>

                  <div class="notif-item" *ngFor="let n of notifs">
                    <div class="casestl">
                      <div class="btn_delete" [class.loading]="eliminandoNotifId === n.id" title="Eliminar notificación"
                        (click)="!eliminandoNotifId && eliminarNotificacion(n)">
                        <img src="assets/iconos/borrar.png" />
                      </div>

                      <ng-container [ngSwitch]="n.tipo">
                        <p *ngSwitchCase="'whatsapp'">
                          <i class="fab fa-whatsapp"></i>
                          <b>Whatsapp</b> al Tel. Cel.:<b> {{ n.referencia }}</b>
                        </p>

                        <p *ngSwitchCase="'correo'">
                          <i class="far fa-envelope"></i>
                          <b>Email</b> a la cuenta:<b> {{ n.referencia }}</b>
                        </p>

                        <p *ngSwitchCase="'sms'">
                          <i class="fas fa-comments"></i>
                          <b>SMS</b> al Tel. Cel.:<b> {{ n.referencia }}</b>
                        </p>

                        <p *ngSwitchDefault>
                          {{ n.tipo }}: <b>{{ n.referencia }}</b>
                        </p>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <ng-template #sinNotifs>
                  <div class="cont_info_notificaciones">
                    <h4 class="titleDestino">Medios de notificaciones actuales</h4>
                    <p class="txt-sub">No tienes notificaciones activas en este momento.</p>
                  </div>
                </ng-template>

                <!-- Form de alta (tu bloque actual) -->
                <div class="cont_frmnotificaciones">
                  <h4 class="titleDestino">Activa o actualiza el medio de notificaciones</h4>
                  <p class="txt-sub" style="margin-top: -5px;">
                    Selecciona el medio que desees para recibir notificaciones de tu paquete
                  </p>

                  <select class="selectTema" [(ngModel)]="medioSeleccionado" (change)="onMedioSeleccionado()">
                    <option [ngValue]="null" disabled selected>Selecciona el medio de notificaciones</option>
                    <option value="whatsapp">Whatsapp</option>
                    <option value="correo">Correo</option>
                    <option value="sms">SMS</option>
                  </select>

                  <input *ngIf="medioSeleccionado === 'whatsapp'" class="addmedio" type="tel" maxlength="10"
                    [(ngModel)]="valorMedio" placeholder="Capture su número de Whatsapp" id="inputwha" />
                  <input *ngIf="medioSeleccionado === 'correo'" class="addmedio" type="email" [(ngModel)]="valorMedio"
                    placeholder="Capture su correo" id="inputemail" />
                  <input *ngIf="medioSeleccionado === 'sms'" class="addmedio" type="tel" maxlength="10"
                    [(ngModel)]="valorMedio" placeholder="Capture su num. telefónico" id="inputtel" />

                  <div *ngIf="valorMedio && !esMedioValido" class="error">
                    <p *ngIf="medioSeleccionado === 'correo'">Correo inválido.</p>
                    <p *ngIf="medioSeleccionado === 'whatsapp' || medioSeleccionado === 'sms'">Debe contener exactamente
                      10 dígitos numéricos.</p>
                  </div>

                  <div class="cont_btnUpdate">
                    <button class="btn_actualizardom" style="margin-top: 10px;" (click)="activarNotificacion()"
                      [disabled]="!(medioSeleccionado && valorMedio && esMedioValido)">
                      Activar
                    </button>
                  </div>
                </div>

              </div>


              <div *ngIf="opcionSeleccionada === 'Registrar incidencia' && isLoguedin" class="registrarincidencia">
                <div class="cont-frmincidencia" *ngIf="incidencia === 0 ">
                  <form class="frm-newIncidencia" (ngSubmit)="enviarIncidencia()" #formIncidencia="ngForm">
                    <h4 class="titleDestino">¿Tuviste algún problema? ¡Cuéntanos!</h4>

                    <select class="selectTema forinci" [(ngModel)]="temaSeleccionado" name="tema" required>
                      <option [ngValue]="null" disabled>Tema de ayuda</option>
                      <option *ngFor="let t of temasIncidencia" [ngValue]="t.idtema">{{ t.tema }}</option>
                    </select>

                    <div class="input-icon">
                      <i class="fa-solid fa-paperclip"></i>
                      <label for="addevidencia" class="file-label">Adjuntar evidencia</label>
                      <input type="file" id="addevidencia" class="addevidencia" (change)="onFileSelected($event)"
                        accept="image/png, image/jpeg" multiple />
                    </div>
                    <!-- Contenedor donde se verán los previews -->
                    <div class="cont-preview">
                      <h4 class="titleDestino" *ngIf="imagePreviews.length > 0">Evidencia adjunta</h4>
                      <div class="preview-container">
                        <div class="image-preview" *ngFor="let img of imagePreviews; let i = index">
                          <img [src]="img.url" alt="Preview">
                          <button type="button" class="remove-btn" (click)="removeImage(i)"
                            title="Eliminar imagen">&times;</button>
                        </div>
                      </div>
                    </div>

                    <textarea class="txt_mensaje" [(ngModel)]="mensajeTexto" name="mensaje" placeholder="Mensaje"
                      required></textarea>

                    <div class="cont_btnUpdate">
                      <button class="btn_actualizardom" type="submit"
                        [disabled]="!temaSeleccionado || !mensajeTexto?.trim()">
                        Enviar
                      </button>
                    </div>
                  </form>
                </div>

                <div class="cont-frmincidencia" *ngIf="incidencia === 1">
                  <h4 class="titleDestino">Información de la incidencia registrada</h4>

                  <div class="info_incidencia">
                    <p><span>Folio de incidencia:</span> {{ incidenciaDetalle?.idincidencia }}</p>
                    <p><span>Tema:</span> {{ incidenciaDetalle?.tema }}</p>
                    <p>
                      <span>Fecha de reporte:</span>
                      {{ incidenciaDetalle?.fecha | date:'dd/MM/yyyy' }}
                    </p>
                    <p style="color: #f05a28;"><span>Tipo:</span> {{incidenciaDetalle?.tipo}}</p>
                    <p><span>Estatus:</span> {{ incidenciaDetalle?.estatus }}</p>

                    <!-- Adjuntos -->
                    <div class="cont-preview" style="margin-top: 10px;" *ngIf="adjuntosInc.length; else sinAdjuntos">
                      <h4 class="titleDestino">Imagenes de evidencia</h4>
                      <div class="preview-container">
                        <div class="image-preview" *ngFor="let adj of adjuntosInc; index as i">
                          <img [src]="adj.safeUrl" [alt]="adj?.nombrearchivo || ('Adjunto ' + (i + 1))" />
                        </div>
                      </div>
                    </div>
                    <ng-template #sinAdjuntos>
                      <div class="cont-preview" style="margin-top: 20px;">
                        <h4 class="titleDestino">Evidencia adjunta</h4>
                        <p style="margin:0px 0 0;">Sin archivos adjuntos.</p>
                      </div>
                    </ng-template>

                    <!-- <div class="cont_btnUpdate" style="text-align: center;margin-top: 20px;">
                    <button class="btn_actualizardom" style="width: auto;" (click)="versegincidencia()">
                      <i class="far fa-comment-dots"></i>Ver seguimiento
                    </button>
                  </div> -->

                    <div class="container_frm_reclamacion" *ngIf="validaEsIncidencia()">
                      <h4 class="titleDestino">Proceso de reclamación</h4>
                      <p class="txt-sub" style="margin-top: -5px; font-size: 14px;">Necesitamos algunos datos para
                        ayudarte.</p>

                      <p style="margin-top: 10px;">
                        <span>Llena el siguiente documento: </span>
                        <a href="assets/img/web/documentos/TFP-FO-10-03-Solicitud-de-Reclamacion.pdf"
                          download="NombreDelArchivoDescargado.pdf" style="color: #f05a28;">Solicitud de reclamación</a>
                      </p>
                      <form class="reclamacion_form" id="reclamacionForm" [formGroup]="reclamacionForm"
                        (ngSubmit)="onSubmitReclamo()">
                        <div class="frm_inputs_rec">
                          <span>Captura ó edita lo siguiente</span>
                          <p class="txt-sub" style="margin-top: 0px; font-size: 13px; margin-bottom: 10px;">Ingresa tus
                            datos reales.</p>
                          <div class="content_inputs_upload">
                            <input type="text" placeholder="Nombre completo" formControlName="nombrerec"
                              class="inpt_rec">
                            <input type="text" placeholder="RFC" formControlName="rfcrec" class="inpt_rec">
                            <input type="text" placeholder="Teléfono" formControlName="telrec" class="inpt_rec">
                            <input type="text" placeholder="Correo" formControlName="correorec" class="inpt_rec">
                            <input type="text" placeholder="Identificación" formControlName="identrec" class="inpt_rec">
                            <input type="text" placeholder="Tel. de contacto" formControlName="telcontactorec"
                              class="inpt_rec">
                            <input type="text" placeholder="Correo de contacto" formControlName="correocontactorec"
                              class="inpt_rec">
                          </div>
                        </div>
                        <div class="frm_adjuntos_rec" formGroupName="files">
                          <span>Adjunta los sig. documentos</span>
                          <p class="txt-sub" style="margin-top:0;font-size:13px;margin-bottom:10px;">Restantes por
                            subir: <b>{{ adjuntosRestantes }}</b></p>
                          <div class="content_inputs_upload">
                            <div class="cont_inpt_upload" *ngFor="let item of fields; index as i">
                              <label class="upload-box" [class.success]="success(item.key)" [attr.for]="'file-'+i">
                                <div class="left">
                                  <!-- iconito -->
                                  <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M19 18a3 3 0 0 0-.3-6 5 5 0 0 0-9.7-1.7A4 4 0 0 0 5 14a4 4 0 0 0 1 7h12"
                                      fill="none" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M12 12v8m0-8 3 3m-3-3-3 3" fill="none" stroke="currentColor"
                                      stroke-width="1.5" stroke-linecap="round" />
                                  </svg>

                                  <span *ngIf="!fileNames[item.key]">{{ item.label }}</span>
                                  <span class="filename" *ngIf="fileNames[item.key]">{{ fileNames[item.key] }}</span>
                                </div>

                                <!-- check -->
                                <svg *ngIf="success(item.key)" class="check" viewBox="0 0 24 24" aria-label="Adjuntado">
                                  <path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </label>

                              <input class="visually-hidden" [id]="'file-'+i" type="file" [accept]="accept"
                                [formControlName]="item.key" (change)="onChange(item.key, $event)" />
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="cont_btnUpdate" style="margin-top: 10px;">
                        <button class="btn_actualizardom " type="submit" form="reclamacionForm"
                          [disabled]="reclamacionForm.invalid || adjuntosRestantes > 0 || enviandorec">
                          Enviar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="containerChat-Seg" *ngIf="incidencia === 1">
                  <h4 class="titleDestino">Chat de seguimiento de incidencia</h4>
                  <p class="txt-sub incitxt" style="margin-top: -5px;">Daremos el seguimiento pertinente al proceso de
                    tu envío.</p>

                  <div class="content_chat_seg">
                    <div class="chat_elements" *ngIf="mensajesChat?.length; else sinMensajes">
                      <!-- <div class="chat_elements" #chatContainer *ngIf="mensajesChat.length; else sinMensajes"> -->
                      <ng-container *ngFor="let m of mensajesChat; trackBy: trackMsg">
                        <!-- Soporte -->
                        <div class="msg_support" *ngIf="isSoporte(m)">
                          <span class="title_chat">Soporte</span>
                          <div class="content_txt_msg backforsupport">
                            <div class="msg">{{ m.mensaje }}</div>
                            <div class="msg_datetime">{{ m.fecha }}</div>
                          </div>
                        </div>

                        <!-- Yo -->
                        <div class="msg_user" *ngIf="isYo(m)">
                          <span class="title_chat">Yo</span>
                          <div class="content_txt_msg">
                            <div class="msg">{{ m.mensaje }}</div>
                            <div class="msg_datetime">{{ m.fecha }}</div>
                          </div>
                        </div>

                        <!-- Otros (por si llegan mensajes de terceros) -->
                        <!-- <div class="msg_support" *ngIf="!isSoporte(m) && !isYo(m)">
                            <span class="title_chat">{{ (m.nombre || 'Soporte').trim() }}</span>
                            <div class="content_txt_msg backforsupport">
                              <div class="msg">{{ m.mensaje }}</div>
                              <div class="msg_datetime">{{ m.fecha }}</div>
                            </div>
                          </div> -->
                      </ng-container>


                    </div>

                    <ng-template #sinMensajes>
                      <div class="chat_empty">
                        <p>No hay mensajes todavía. ¡Escribe el primero!</p>
                      </div>
                    </ng-template>



                    <div class="content_elements_tosend">
                      <div class="container_input_info">
                        <input class="input_msg_chat" autocomplete="off" placeholder="Escribir mensaje..."
                          [(ngModel)]="chatMensaje" name="chatMensaje" [disabled]="enviandoMsg"
                          (keyup.enter)="enviarMensajeIncidencia()">
                        <!-- <i class="fas fa-paperclip fta"></i> -->
                      </div>
                      <div class="cont_btn_chat">
                        <button type="button" class="btn_disabled" (click)="enviarMensajeIncidencia()"
                          [disabled]="enviandoMsg || !chatMensaje?.trim() || incidenciaDetalle?.estatus === 'CAN'">
                          <i class="fas fa-paper-plane fta"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="opcionSeleccionada === 'Programar entrega'" class="programarEntrega">
                <div class="left_content_entrega">
                  <h4 class="titleDestino">Fecha estimada de entrega</h4>
                  <p class="txt-sub" style="margin-top: -5px;">
                    Visualiza el progreso de tu envío en cada etapa del proceso de entrega.
                  </p>

                  <!-- ✅ Si hay programación, muestra los datos -->
                  <ng-container *ngIf="programacion; else sinProgramacion">
                    <div class="info_estatus_entrega">
                      <div class="cont_clock">
                        <img src="assets/iconos/clock.png" alt="icon_clock">
                      </div>
                      <div class="info_estimacion">
                        <p><b>Entrega:</b> {{ programacionFechaLegible || '—' }}</p>
                        <p><b>Horario:</b> {{ programacion?.rango ? (programacion.rango + ' hrs') : '—' }}</p>
                        <p><b>Motivo:</b> {{ programacion?.motivo || '—' }}</p>
                        <p><b>Instrucciones:</b> {{ programacion?.instrucciones || '—' }}</p>
                      </div>
                    </div>
                  </ng-container>

                  <!-- 🆕 Si NO hay programación, muestra solo un texto -->
                  <ng-template #sinProgramacion>
                    <div class="info_estatus_sinentrega">
                      <div class="cont_clock">
                        <img src="assets/iconos/clock.png" alt="icon_clock"
                          style="width: 80px;height: auto;margin-top: 15px;">
                      </div>
                      <div class="centerEmpty">
                        <p style="margin:0;">
                          <b>¿Deseas sugerir una nueva fecha de entrega?</b>
                          <br>
                          Captura los datos necesarios en "Programar entrega"
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </div>
                <div class="right_content_programacion">
                  <h4 class="titleDestino">Programar entrega</h4>
                  <p class="txt-sub" style="margin-top: -5px;">Selecciona el día y hora que prefieras recibir tu
                    paquete.<br><span>Haremos todo lo posible por entregarlo en la fecha que elijas.</span></p>

                  <div class="container-frm-prog">
                    <form>
                      <div class="cont_calendar">
                        <div class="calendar-container">
                          <div class="calendar-header">
                            <button (click)="prevMonth()">&lt;</button>
                            <span>{{ currentDate | date:'MMMM yyyy' }}</span>
                            <button (click)="nextMonth()">&gt;</button>
                          </div>

                          <div class="calendar-grid">
                            <div class="day-name" *ngFor="let day of ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb']">
                              {{ day }}
                            </div>

                            <div *ngFor="let week of weeks">
                              <div class="calendar-day" *ngFor="let day of week" [class.empty]="!day"
                                [class.selected]="selectedDate && day?.toDateString() === selectedDate.toDateString()"
                                (click)="day && selectDate(day)">
                                {{ day?.getDate() || '' }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <img src="assets/iconos/calendar_img.png" alt="icon_calendar"> -->
                        <!-- RANGO DE HORA -->
                        <select class="selectTema" [(ngModel)]="rangoSeleccionado" name="rangoHora" required
                          style="margin-top: 10px;">
                          <option [ngValue]="null" disabled>Rango de hora</option>
                          <option *ngFor="let r of rangosHorarios" [ngValue]="r.idtema">
                            {{ r.tema }}
                          </option>
                        </select>
                      </div>

                      <div class="datos_prog">
                        <!-- MOTIVO -->
                        <!-- <select class="selectTema" [(ngModel)]="motivoSeleccionado" name="motivo" required>
                          <option [ngValue]="null" disabled>Seleccione un motivo</option>
                          <option *ngFor="let m of temasMotivos" [ngValue]="m.idtema">
                            {{ m.tema }}
                          </option>
                        </select> -->

                        <select class="selectTema" [(ngModel)]="motivoSeleccionado" name="motivo" required>
                          <option [ngValue]="null" disabled>Seleccione un motivo</option>
                          <option *ngFor="let m of motivos" [ngValue]="m.idtema">
                            {{ m.tema }}
                          </option>
                        </select>
                        <textarea class="txt_mensaje" [(ngModel)]="instruccionesEntrega" name="instruccionesEntrega"
                          placeholder="Instrucciones de entrega">
                        </textarea>
                        <div class="cont_btnUpdate" style="text-align: right;">
                          <button class="btn_actualizardom" type="button" (click)="programarEntrega()"
                            [disabled]="!puedeProgramar">
                            <i class="far fa-clock"></i>Programar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>


            </div>
          </div>
    </div>
    <ng-template #noInfo>
      <div class="right_container2">
        <div class="defaultInfo">
          <img src="assets/iconos/info_recol.png">
          Selecciona un rastreo para visualizar mas información
        </div>

      </div>
    </ng-template>

  </div>

</div>